<template>
    <!-- https://www.highcharts.com/demo/error-bar for reference -->
    <div>
        <highcharts :options="chartOptions"></highcharts>
        <div>
            <div style="float: right;">
                <b-button-group size="sm">
                    <b-button variant="primary" :pressed.sync="buttonsPressed['scatter']" @click="switchChartType('scatter')">Scatter</b-button>
                    <b-button class="" variant="primary" :pressed.sync="buttonsPressed['bar']" @click="switchChartType('bar')">Bar</b-button>
                    <b-button class="" variant="primary" :pressed.sync="buttonsPressed['spline']" @click="switchChartType('spline')">Spline</b-button>
                </b-button-group>
            </div>
        </div>
    </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'

highchartsMore(Highcharts) // needed for error bars

export default {
        mixins: [],
        components: {
        highcharts: Chart,
    },
    props: {
        chartSeriesArray: Array,
    },
data() {
    return {
        buttonsPressed: {
            scatter: true,
            bar: false,
            spline: false
        },
        chartOptions: {
            chart: {
                // backgroundColor: {},
                inverted: false,
                type: 'scatter',
                // zoomType: 'xy'
            },
            credits: {
                enabled: false, // remove the "Highcharts.com" credit in the corner of the graph.
            },
            title: {
                // text: // determined by initChart() = this.chartSeriesArray[0][0][0] "Dataset ID"
            },
            // caption: {
            //     text: 'Chart Caption'
            // },
            xAxis: [{
                gridLineWidth: 1, // vertical grid lines
                gridLineColor: '#BBB',
                // categories: null, 
                title: {
                    //text: // determined by initChart() = this.chartSeriesArray[0][0][7] + 
                    // ' ('+ this.chartSeriesArray[0][0][9] + ')' "X Axis Name + ' ('+ X Axis Unit + ')',
                    style: {
                        color: '#555' // Color of X-axis label
                    }
                }
            }],
            yAxis: [{ // Primary yAxis
                gridLineColor: '#BBB',
                labels: {
                    format: '{value}',
                    style: {
                        color: '#555' // Color of the Y-axis NUMERICAL labels
                    }
                },
                title: {
                    text: this.yaxisName + '<br>('+ this.yaxisUnit + ')',
                    style: {
                        color: '#555' // Color of the Y-axis TEXT labels
                    }
                }
            }],

            tooltip: {
                shared: true
            },
            legend: {
                enabled: true
            },
            series: []
        }
    }
},
computed: {},
created: function() {
this.initchart();
},
mounted: function() {},
methods: {
    initchart() {
        // Data (chartSeriesArray) comes in as an array of arrays which represent a series to be plotted.
        // Each series array contains an objects that represent one POINT.
        // These points are formatted as:
        // {OID, Y-name, Y-val, Y-unit, Errorpos, Errorneg, X-name, X-val, X-unit, Location}
        // chartSeries is an array of arrays of arrays.
        // chartSeries[0] is a series array--
        // chartSeries[0][0] is a point object (array)
        // chartSeries[0][0][0] is a single item of data from the point--in this case the dataset ID.

        const that = this;

        // Set chart title
        // this.chartOptions.title.text = this.chartSeriesArray[0][0][0];
        this.chartOptions.title.text = "";
        // Set X axis title
        this.chartOptions.xAxis[0].title.text = this.chartSeriesArray[0][0][6] +
                                                ' ('+ this.chartSeriesArray[0][0][8] + ')';
        // Set Y axis title
        this.chartOptions.yAxis[0].title.text = this.chartSeriesArray[0][0][1] +
                                                '<br>('+ this.chartSeriesArray[0][0][3] + ')';

        // for each series in chartSeriesArray:
        let i = 0;
        this.chartSeriesArray.forEach(function(series) {
            
            // sort the series by X coord and then Y coord
            let sorted = that.sortSeriesArray(series);
            
            // get it's X Y coords and error bar data
            let coordinateData = that.getXYCoordsAndErrorBars(sorted);

            // push the series' XY data into the chartOptions
            that.chartOptions.series[i] = new Object();
            that.chartOptions.series[i].name = sorted[0][9] + ": " + sorted[0][10];
            that.chartOptions.series[i].data = coordinateData[0];
            that.chartOptions.series[i].marker = new Object();
            that.chartOptions.series[i].marker.symbol = 'circle';
            that.chartOptions.series[i].marker.enabled = true;
            i++;

            if(coordinateData[2]){
                // push the first series' error bar data into the chartOptions
                that.chartOptions.series[i] = new Object();
                that.chartOptions.series[i].name = sorted[0][10] + " Error Range";
                that.chartOptions.series[i].type = "errorbar";
                that.chartOptions.series[i].data = coordinateData[1];
                i++;
            }
        });
    },
    sortSeriesArray(arr) {
    // sort coordinates by X ascending and then Y ascending
    var sortedArray = arr.sort(function(a, b) {
        if (a[7] == b[7]) {
            return a[2] - b[2];
        }
        return a[7] - b[7];
    });

    return sortedArray;
    },
    getXYCoordsAndErrorBars(arr) {
        const XYCoords = [];
        const errorArray = [];
        let errorDataPresent = false;

        arr.forEach(function(coord) {
            const coordinate = [];
            coordinate[0] = coord[7]; // X coord value
            coordinate[1] = coord[2]; // Y coord value
            XYCoords.push(coordinate);

            const posNegVals = [];
            posNegVals[0] = coord[7];             // the X coord in the ErrorBar Series
            posNegVals[1] = coord[2]- coord[5];   // the Y coord low in the ErrorBar Series
            posNegVals[2] = coord[2]+ coord[4];   // the Y coord high in the ErrorBar Series
            errorArray.push(posNegVals);

            if (!(coord[5] == null || coord[5] == undefined) || !(coord[4] == null || coord[4] == undefined)){
                errorDataPresent = true;
            }
        });
        return [XYCoords, errorArray, errorDataPresent];
    },
    switchChartType(type){
        // set the chart to the provided type
        this.chartOptions.chart.type = type;

        // set all of the buttons to pressed = false
        for (let button in this.buttonsPressed) {
          this.buttonsPressed[button] = false;
        }

        // set the selected button to pressed = true
        this.buttonsPressed[type] = true;
    },
  }
};
</script>
<style>
.btn-primary:not(:disabled):not(.disabled):active, 
.btn-primary:not(:disabled):not(.disabled).active, 
.show > .btn-primary.dropdown-toggle {
    background-color: #387599 !important;
}
</style>
